import { request } from "../helper/axios_helper";

export const getAllResultSummary = () => {
  return request("GET", "/api/auth/result/fetch/summary");
};

export const getResultSummaryByKey = (key) => {
  return request("GET", `/api/auth/result/fetch/summary/${key}`);
};

export const getTestResultSummary = (key) => {
  return request("GET", `/api/auth/result/test/summary/${key}`);
};

export const getTestResultDetail = (key) => {
  return request("GET", `/api/auth/result/test/detail/${key}`);
};

export const getTestResultLogFail = (key, testStatus) => {
  return request(
    "GET",
    `/api/auth/result/test/detail/column/fail/${key}/${testStatus}`,
  );
};

export const getTestResultLog = (key) => {
  return request("GET", `/api/auth/result/test/detail/column/fail/${key}`);
};

export const getMasterSuiteDetailResultByJob = (suiteJobId) => {
  return request(
    "GET",
    `/api/auth/result/test/mastersuite/detail/${suiteJobId}`,
  );
};

export const getUITestSteps = (summaryKey) =>
  request("GET", `/api/auth/result/ui/steps/${summaryKey}`);
